/**
 * Contributor
 * @author Nicolas Venne
 *
 * @copyright Klipfolio, All rights reserved
 */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from '@icons'
import Text from '@particles/text'
import Social from '@atoms/social'
import Link from '@atoms/link'
import Image from '@atoms/image'

const propTypes = {
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  web: PropTypes.string,
  twitter: PropTypes.string,
  linkedin: PropTypes.string,
  imageAlt: PropTypes.string,
  imageFile: PropTypes.object,
  forSearch: PropTypes.bool,
  radius: PropTypes.string
}

const StyledContributor = styled.div`
  display: grid;
  column-gap: 10px;
  margin: 0.5rem 0;
  margin-right: ${(props) => props.forSearch ? '1rem' : '0'};
  grid-template-columns: ${(props) => props.forSearch ? '48px' : '77px'} auto;
  grid-template-rows: ${(props) => props.forSearch ? '48px' : '77px'};
  grid-template-areas:
    'icon name'
    'empty links';
`

const StyledNameContainer = styled.div`
  grid-area: name;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

const StyledLinksContainer = styled.div`
  grid-area: links;
  display: flex;
  ${Social} {
    height: auto;
    width: auto;
  }
  margin-top: 0.5rem;

  svg {
    height: 24px;
    width: 24px;
    margin: 0 6px 0 0;
  }
`

const StyledIcon = styled.div`
  width: 100%;
  height: 100%;
  border-radius: ${(props) => props.radius ?? '50%'};
  grid-area: icon;
  background-color: #d7dcea;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
`

const Contributor = ({
  name,
  subtitle,
  web,
  twitter,
  linkedin,
  imageFile,
  imageAlt,
  forSearch,
  radius
}) => {
  return (
    <StyledContributor forSearch={forSearch}>
      <StyledIcon radius={radius}>
        {imageFile ? (
          <Image file={imageFile} alt={imageAlt} />
        ) : (
          <Icon name={'user'} size={4.8125} />
        )}
      </StyledIcon>
      <StyledNameContainer>
        {web ? (
          <Link to={web}>
            {name}
          </Link>
        ) : (
          <Text as={'span'} color={'#000000'}>
            {name}
          </Text>
        )}
        {subtitle && <Text as={'span'} margin={'T0.1'} size={0.75} color={'#485066'}>
          {subtitle}
        </Text>}
        {(twitter || linkedin) && <StyledLinksContainer>
        {twitter && <Social.Twitter href={twitter} />}
        {linkedin && <Social.LinkedIn href={linkedin} />}
      </StyledLinksContainer>}
      </StyledNameContainer>
    </StyledContributor>
  )
}

Contributor.propTypes = propTypes
export default Contributor
